import wrapWithProvider from './wrap-with-provider';
import { PageWrapper } from './wrap-page-element';
import tailwindPaths from './config/migrated-pathes.json';
import '@rategravity/widgets-react-css/styles.css';
import './src/styles/tailwind.global.css';

export const wrapRootElement = wrapWithProvider;
export const wrapPageElement = PageWrapper;

export const onClientEntry = () => {
  require('regenerator-runtime');
};

export const onRouteUpdate = ({ location }) => {
  // Pages styled with styled-components generate style tags with "styled-components" ID on server side.
  // When navigating between pages in Gatsby, these styles persist in the DOM.
  // On routes using Tailwind CSS, these leftover styles can interfere with the layout.
  // To prevent style conflicts, these style tags should be removed when navigating to Tailwind-styled routes.
  if (tailwindPaths.tailwindPaths.includes(location.pathname)) {
    const jssStyles = document.getElementById('styled-components');
    if (jssStyles) {
      jssStyles.parentNode.removeChild(jssStyles);
    }
  }
}
